import { createContext } from 'react';

import { RadioGroupProps } from './RadioGroup';

interface ContextValues {
  id: RadioGroupProps['id'];
  disabled?: boolean;
  value: RadioGroupProps['value'];
  onChange: RadioGroupProps['onChange'];
  name: string;
  'aria-describedby'?: string;
}

export const RadioGroupContext = createContext<ContextValues | null>(null);

export const RadioItemContext = createContext<number | null>(null);
